module.exports = __webpack_public_path__ + "img/pg-boring.43d430ba.jpg";